module.exports = __webpack_public_path__ + "static/media/gtt-thewall-5.477255e9.svg";